import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100vh;

	.header {
		display: flex;
		flex-direction: column;
		gap: 5px;
		align-items: center;
		img {
			width: 180px;
			margin: none;
			padding: none;
		}
		h1 {
			font-size: 48px;
			font-weight: 900;
			margin: none;
		}
	}

	.input-cover {
		display: flex;
		flex-direction: column;
		gap: 15px;
	}

	.input-wrapper {
		display: flex;
		align-items: center;
		width: max-content;
		gap: 5px;
		label {
			font-size: 14px;
			font-weight: 800;
			align-self: self-start;
		}
		input {
			width: 650px;
			height: 50px;
			padding: 0 15px;
			border-radius: 10px;
			border: 2px solid var(--dark-green);
		}
	}

	span {
		font-style: italic;
		color: gray;
		font-size: 15px;
	}

	button {
		width: 300px;
		padding: 20px;

		background-color: var(--dark-blue);
		margin: 20px 0;
		border-radius: 10px;
		color: white;
		transition: 300ms ease;
	}

	button:hover {
		background-color: var(--main-blue);
	}
`;
